import React from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { BookOpen, FileText } from 'lucide-react';

const Research = () => {
  // Mock research papers data
  const researchPapers = [
    {
      title: 'Impact of Digital Marketing on Consumer Behavior',
      author: 'Dr. A. B. Patil',
      year: '2023',
      journal: 'International Journal of Commerce and Management',
      category: 'Marketing'
    },
    {
      title: 'Financial Literacy among College Students',
      author: 'Prof. S. V. Shinde',
      year: '2023',
      journal: 'Journal of Financial Education',
      category: 'Finance'
    },
    {
      title: 'E-Commerce Growth in Rural India',
      author: 'Dr. M. R. Desai',
      year: '2022',
      journal: 'Asian Journal of Business Research',
      category: 'E-Commerce'
    },
    {
      title: 'Corporate Social Responsibility and Brand Image',
      author: 'Dr. P. K. Jadhav',
      year: '2022',
      journal: 'International Business Review',
      category: 'Management'
    },
    {
      title: 'Impact of GST on Small Business Enterprises',
      author: 'Prof. R. S. Kulkarni',
      year: '2021',
      journal: 'Indian Journal of Taxation',
      category: 'Taxation'
    },
    {
      title: 'Women Entrepreneurship in Maharashtra',
      author: 'Dr. N. A. Pawar',
      year: '2021',
      journal: 'Journal of Entrepreneurship Studies',
      category: 'Entrepreneurship'
    }
  ];

  const categories = [...new Set(researchPapers.map(paper => paper.category))];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Navigation />
      
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-[#000066] mb-2 flex items-center gap-3">
            <BookOpen className="w-10 h-10" />
            Published Research Papers
          </h1>
          <p className="text-gray-600">Academic contributions by our faculty members</p>
        </div>

        {/* Category Filter */}
        <div className="mb-8 flex flex-wrap gap-3">
          <button className="px-4 py-2 bg-[#000066] text-white rounded-lg hover:bg-[#000099] transition-colors">
            All
          </button>
          {categories.map((category, index) => (
            <button
              key={index}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
            >
              {category}
            </button>
          ))}
        </div>

        {/* Research Papers Grid */}
        <div className="grid gap-6">
          {researchPapers.map((paper, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border-l-4 border-[#FF4500]"
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <FileText className="w-5 h-5 text-[#FF4500]" />
                    <span className="text-xs font-semibold text-white bg-[#000066] px-3 py-1 rounded-full">
                      {paper.category}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-[#000066] mb-2">
                    {paper.title}
                  </h3>
                  <p className="text-gray-700 mb-1">
                    <span className="font-semibold">Author:</span> {paper.author}
                  </p>
                  <p className="text-gray-700 mb-1">
                    <span className="font-semibold">Journal:</span> {paper.journal}
                  </p>
                  <p className="text-gray-600 text-sm">
                    <span className="font-semibold">Year:</span> {paper.year}
                  </p>
                </div>
                <div className="ml-4">
                  <button className="px-4 py-2 bg-[#FF4500] text-white rounded hover:bg-[#FF5722] transition-colors">
                    View PDF
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Research;